module.exports = __webpack_public_path__ + "static/media/bell-clicked.bde52f8d.svg";